module.exports = __webpack_public_path__ + "img/laboratorio2_4-3_682.47bd6bb5.jpg";